import React, { useContext, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import styled from "styled-components";
import PageTabs from "./PageTabs";
import SearchFilterBar from "./SearchFilterBar";
import { useSelector } from "react-redux";
import moment from "moment";
import { OwcButton } from "@one/react";
import CustomFilterWrapper, { initialState } from "../custom-filter/CustomFilterWrapper";
import SearchTextWrapper from ".././log-book-item-fillter/suggester/search-context/SearchTextWrapper";
import PaginationWrapper from "../../../components/shared/pagination/PaginationWrapper";
import RunLogsPage from ".././log-book-pages/RunLogsPage";
import LogSheetPage from ".././log-book-pages/LogSheetPage";
import ChangeLogSheetPage from ".././log-book-pages/ChangeLogSheetPage";
import { CoverSheetMainPageContext } from "../../cover-sheet/cover-sheet-main-page-context/context";
import { APP_PATHS, entryType, equipmentStatus, formStates, formTypes } from "../../../constants";
import LogbookSelectedWrapper from "../log-book-table/logBooksSelectAll/LogBookSelectedWrapper";
import AllLogsPage from ".././log-book-pages/AllLogsPage";
import { react18WorkaroundProps } from "../../../utils/constants/react18WorkaroundProps";

const MainContainer = styled.div``;

const LogTypeContent = ({ logType, logBookEquipment }) => {
  if (logType === formTypes.RUN_LOG) {
    return (
      <LogbookSelectedWrapper equipmentDetail={logBookEquipment}>
        <RunLogsPage equipmentDetail={logBookEquipment} />
      </LogbookSelectedWrapper>
    );
  }
  if (logType === formTypes.ACTION_LOG) {
    return (
      <LogbookSelectedWrapper equipmentDetail={logBookEquipment}>
        <LogSheetPage equipmentDetail={logBookEquipment} />
      </LogbookSelectedWrapper>
    );
  }
  if (logType === formTypes.CHANGE_LOG) {
    return <ChangeLogSheetPage equipmentDetail={logBookEquipment} />;
  }
  if (logType === formTypes.ALL_LOG) {
    return (
      <LogbookSelectedWrapper equipmentDetail={logBookEquipment}>
        <AllLogsPage equipmentDetail={logBookEquipment} />
      </LogbookSelectedWrapper>
    );
  }
  return null;
};

const AddClusterLogButton = ({
  inventoryId,
  isClusterCoverSheet,
  loadLogBookEquipment,
  loadFormState,
  handleOpenWorkFlowModel,
  logBookEquipment,
  tabValue
}) => (
  <OwcButton
    {...react18WorkaroundProps}
    variant="secondary"
    onClick={() => {
      if (!inventoryId) {
        loadLogBookEquipment(null);
      }
      loadFormState(null);
      handleOpenWorkFlowModel({
        isCluster: isClusterCoverSheet,
        form: inventoryId ? formStates.PARTIAL_NEW_FORM : formStates.NEW_FORM
      });
    }}
    disabled={logBookEquipment?.clusterId}
  >
    {tabValue}
  </OwcButton>
);

const AddStandaloneLogButton = ({ inventoryId, logBookEquipment, logType, history }) => {
  const isActionLog = logType === formTypes.ACTION_LOG;
  const handleClick = () => {
    sessionStorage.setItem(
      "equipmentIdList",
      JSON.stringify([logBookEquipment?.inventoryId].filter(Boolean))
    );
    if (inventoryId) {
      sessionStorage.setItem("addLogReturnPath", `/cover-sheet/${inventoryId}`);
    } else {
      sessionStorage.removeItem("addLogReturnPath");
    }
    history.push(isActionLog ? APP_PATHS.ACTION_LOG : APP_PATHS.RUN_LOG);
  };

  return (
    <OwcButton {...react18WorkaroundProps} variant="secondary" onClick={handleClick}>
      Add {isActionLog ? "Action" : "Run"} log(s)
    </OwcButton>
  );
};

const AddLogButtonContainer = ({
  isClusterCoverSheet,
  inventoryId,
  logBookEquipment,
  loadLogBookEquipment,
  loadFormState,
  handleOpenWorkFlowModel,
  tabValue,
  logType,
  history
}) => (
  <div
    style={{
      marginTop: "15px",
      marginRight: "30px",
      float: "right"
    }}
  >
    {isClusterCoverSheet ? (
      <AddClusterLogButton
        inventoryId={inventoryId}
        isClusterCoverSheet={isClusterCoverSheet}
        loadLogBookEquipment={loadLogBookEquipment}
        loadFormState={loadFormState}
        handleOpenWorkFlowModel={handleOpenWorkFlowModel}
        logBookEquipment={logBookEquipment}
        tabValue={tabValue}
      />
    ) : (
      <AddStandaloneLogButton
        inventoryId={inventoryId}
        logBookEquipment={logBookEquipment}
        logType={logType}
        history={history}
      />
    )}
  </div>
);

const LogBooksMainPage = () => {
  const history = useHistory();
  const { inventoryId } = useParams();
  const storeUser = useSelector((store) => store.user);
  const { tabValue, handleOpenWorkFlowModel, logBookEquipment, loadLogBookEquipment, logType, loadFormState } =
    useContext(CoverSheetMainPageContext);
  const canEdit = useSelector((store) => store.user.canEdit);
  const initialLog = {
    site: storeUser?.site,
    dateFrom: moment(new Date()).subtract(30, "days").format("YYYY-MM-DD"),
    dateTo: moment(new Date()).format("YYYY-MM-DD"),
    inputsState: {
      ...initialState.inputsState,
      site: storeUser?.site,
      dateFrom: moment(new Date()).subtract(30, "days").format("YYYY-MM-DD"),
      dateTo: moment(new Date()).format("YYYY-MM-DD")
    }
  };
  const initialRunLog = initialLog;
  const initialActionLog = initialLog;

  useEffect(() => {
    if (!inventoryId) {
      loadLogBookEquipment(null);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const isClusterCoverSheet = inventoryId && logBookEquipment?.entryType === entryType?.cluster;

  const isAddLogButtonVisible =
    tabValue !== "change" &&
    tabValue !== "All logs" &&
    (!inventoryId || isClusterCoverSheet || logBookEquipment?.status === equipmentStatus?.active?.key) &&
    canEdit;

  return (
    <>
      <MainContainer
        data-testid="log-book-main-page"
        style={{
          width: inventoryId === null ? "100%" : ""
        }}
      >
        <CustomFilterWrapper initialValues={logType !== formTypes.ACTION_LOG ? initialRunLog : initialActionLog}>
          <PaginationWrapper>
            <SearchTextWrapper>
              {/* search bar  */}
              <SearchFilterBar value={logType} equipmentDetail={logBookEquipment} />
              <PageTabs value={logType} />
              <LogTypeContent logType={logType} logBookEquipment={logBookEquipment} />
            </SearchTextWrapper>
          </PaginationWrapper>
        </CustomFilterWrapper>
      </MainContainer>
      {isAddLogButtonVisible && (
        <AddLogButtonContainer
          isClusterCoverSheet={isClusterCoverSheet}
          inventoryId={inventoryId}
          logBookEquipment={logBookEquipment}
          loadLogBookEquipment={loadLogBookEquipment}
          loadFormState={loadFormState}
          handleOpenWorkFlowModel={handleOpenWorkFlowModel}
          tabValue={tabValue}
          logType={logType}
          history={history}
        />
      )}
    </>
  );
};

export default LogBooksMainPage;
